import React, { useEffect, useLayoutEffect } from 'react';
import { DateTime } from 'luxon';
import { Map as ImmutableMap } from 'immutable';

import { dismissErrorPage, errorsBlackList, treatAsWarning } from 'utils/core/bugsnag';
import QIllustrationInternal from 'components/QIllustration/QIllustrationInternal';

import Tooltip from '@mui/material/Tooltip';
import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded';
import Chip from '@mui/material/Chip';

import { useAppDispatch } from 'app-components/hooks/redux';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

let loopBreakerTime = DateTime.now();

type Props = {
  error: Error;
  clearError?: () => void;
};

const FallbackComponentXS = ({ error, clearError }: Props) => {
  useEffect(() => dismissErrorPage(), []);

  useLayoutEffect(() => {
    const context = `${error.name}:${error.message}`;
    if (
      (DateTime.now().diff(loopBreakerTime, 'minutes').minutes > 5 &&
        errorsBlackList.find((mask) => (typeof mask === 'string' ? context.includes(mask) : mask.test?.(context)))) ||
      treatAsWarning.find((mask) => (typeof mask === 'string' ? context.includes(mask) : mask.test?.(context)))
    ) {
      loopBreakerTime = DateTime.now();
      clearError?.();
    }
  }, [error, clearError]);

  const dispatch = useAppDispatch();

  return (
    <Tooltip title='Oops! Something went wrong. Click to reload.' placement='bottom'>
      <Chip
        sx={{ width: 'fit-content' }}
        variant='outlined'
        color='warning'
        size='small'
        label='oops!'
        avatar={<QIllustrationInternal name='planeCrash' size='xxs' />}
        onClick={() => window.location.reload()}
        deleteIcon={
          <Tooltip title='Send Feedback' placement='top'>
            <ReportGmailerrorredRoundedIcon fontSize='small' />
          </Tooltip>
        }
        onDelete={() => {
          dispatch(
            rootUiActions.createDialog(
              rootUiTypes.mkRootUiData({
                id: 'report-error',
                type: 'DIALOG_TYPE_REPORT_ERROR',
                allowNesting: true,
                props: ImmutableMap({
                  feedbackSubject: 'Report React Crash',
                }),
              }),
            ),
          );
        }}
      />
    </Tooltip>
  );
};

FallbackComponentXS.whyDidYouRender = false;

export default FallbackComponentXS;
